export default __webpack_public_path__ + "logo-appstore-fr-68f435033b1a6bf44d861ac19581e644.svg";